<template>
  <div class="module-sub-tag">
    <div class="module-sub-tag-name">{{data.name}}</div>
    <div class="module-sub-tag-value">
      <span v-for="(v, i) in data.value" :key="i" class="module-sub-tag-value-item">
        {{format(v)}}
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    config: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    format (v) {
      if (this.data.ref) {
        let ref = this.config[this.data.ref]
        let o = _.find(ref, {value: v})
        return _.get(o, 'label', v)
      }
      return v
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.module-sub-tag {
  display: flex;
  @media (--mediaPc) {
    padding: 12px 0;
    margin: 0 53px;
  }
  @media (--mediaMobile) {
    padding: 0 0 calc(24px / var(--scaleMobile));
    margin-left: 40px;
    margin-right: 25px;
  }
  & .module-sub-tag-name {
    white-space: nowrap;
    vertical-align: top;
    font-weight: bold;
    @media (--mediaPc) {
      margin-right: 24px;
    }
    @media (--mediaMobile) {
      margin-right: calc(24px / var(--scaleMobile));
    }
  }
  & .module-sub-tag-value {
    color: var(--colorGray0);
    & .module.sub-tag-value-item {

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/sub/Tag.vue